import { fetcher } from "helpers/fetcher";

import { TGetListStaffReq, TGetListStaffRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getListStaff = async (payload: TGetListStaffReq) => {
  return await fetcher<TGetListStaffRes, TGetListStaffReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_LIST_STAFF,
    {
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
      },
      data: payload.data,
    }
  );
};

export const queryGetListStaff = async (payload: TGetListStaffReq) => {
  return await getListStaff(payload);
};

queryGetListStaff._key = (payload?: TGetListStaffReq) => [
  ENDPOINT.MANAGEMENT.GET_LIST_STAFF.url,
  payload,
];
